import{define as e}from"../../internal/call-define.js";import t from"./component.js";var n=e(t);export{n as default};
//# sourceMappingURL=definition.js.map
